const ImsIconUrlLookupImpl = {
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'add-chart': 'assets/icons/add-chart.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'add-status': 'assets/icons/add-status.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'add-table': 'assets/icons/add-table.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    addChart: 'assets/icons/add-chart.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    addStatus: 'assets/icons/add-status.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    addTable: 'assets/icons/add-table.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agBridge: 'assets/icons/map/ag_bridge.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agBuilding: 'assets/icons/map/ag_building.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agCoolRoom: 'assets/icons/map/ag_cool_room.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agDam: 'assets/icons/map/ag_dam.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agErosion: 'assets/icons/map/ag_erosion.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agFence: 'assets/icons/map/ag_fence.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agGate: 'assets/icons/map/ag_gate.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agHouse: 'assets/icons/map/ag_house.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agIrrigator: 'assets/icons/map/ag_irrigator.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agMob: 'assets/icons/map/ag_mob.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agNote: 'assets/icons/map/ag_note.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agPaddock: 'assets/icons/map/ag_paddock.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agPond: 'assets/icons/map/ag_pond.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agShed: 'assets/icons/map/ag_shed.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agSilo: 'assets/icons/map/ag_silo.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agSpreader: 'assets/icons/map/ag_spreader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agTank: 'assets/icons/map/ag_tank.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agTask: 'assets/icons/map/ag_task.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agVegetation: 'assets/icons/map/ag_vegetation.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agWaterway: 'assets/icons/map/ag_waterway.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    agYard: 'assets/icons/map/ag_yard.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_bridge: 'assets/icons/map/ag_bridge.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_building: 'assets/icons/map/ag_building.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_cool_room: 'assets/icons/map/ag_cool_room.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_dam: 'assets/icons/map/ag_dam.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_erosion: 'assets/icons/map/ag_erosion.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_fence: 'assets/icons/map/ag_fence.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_gate: 'assets/icons/map/ag_gate.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_herd: 'assets/icons/map/ag_herd.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_house: 'assets/icons/map/ag_house.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_irrigator: 'assets/icons/map/ag_irrigator.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_mob: 'assets/icons/map/ag_mob.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_note: 'assets/icons/map/ag_note.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_paddock: 'assets/icons/map/ag_paddock.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_pond: 'assets/icons/map/ag_pond.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_shed: 'assets/icons/map/ag_shed.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_silo: 'assets/icons/map/ag_silo.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_spreader: 'assets/icons/map/ag_spreader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_tank: 'assets/icons/map/ag_tank.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_task: 'assets/icons/map/ag_task.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_vegetation: 'assets/icons/map/ag_vegetation.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_waterway: 'assets/icons/map/ag_waterway.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ag_yard: 'assets/icons/map/ag_yard.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    aggregate: 'assets/icons/aggregate.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'aggregate-white': 'assets/icons/aggregate-white.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    aggregateWhite: 'assets/icons/aggregate-white.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    aquaticHealth: 'assets/icons/map/aquatic_health.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    aquatic_health: 'assets/icons/map/aquatic_health.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    assetTags: 'assets/icons/asset_tags.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    asset_tags: 'assets/icons/asset_tags.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    atv: 'assets/icons/map/atv.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'auto-refresh': 'assets/icons/auto-refresh.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    autoRefresh: 'assets/icons/auto-refresh.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    backhoeLoader: 'assets/icons/map/backhoe_loader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    backhoe_loader: 'assets/icons/map/backhoe_loader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    baseIcon: 'assets/icons/map/indicators/base_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    base_icon: 'assets/icons/map/indicators/base_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    birdCount: 'assets/icons/map/bird_count.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    bird_count: 'assets/icons/map/bird_count.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    boat: 'assets/icons/map/boat.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    boomBarrier: 'assets/icons/map/boom_barrier.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    boom_barrier: 'assets/icons/map/boom_barrier.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    building: 'assets/icons/map/building.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    bus: 'assets/icons/map/bus.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    calculator: 'assets/icons/calculator.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    camera: 'assets/icons/camera.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cargoShipFront: 'assets/icons/map/cargo_ship_front.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cargoShipSide: 'assets/icons/map/cargo_ship_side.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cargo_ship_front: 'assets/icons/map/cargo_ship_front.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cargo_ship_side: 'assets/icons/map/cargo_ship_side.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cctv: 'assets/icons/map/cctv.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'chevron-collapse': 'assets/icons/chevron-collapse.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'chevron-down': 'assets/icons/chevron-down.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'chevron-expand': 'assets/icons/chevron-expand.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'chevron-left': 'assets/icons/chevron-left.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'chevron-right': 'assets/icons/chevron-right.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'chevron-up': 'assets/icons/chevron-up.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    chevronCollapse: 'assets/icons/chevron-collapse.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    chevronDown: 'assets/icons/chevron-down.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    chevronExpand: 'assets/icons/chevron-expand.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    chevronLeft: 'assets/icons/chevron-left.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    chevronRight: 'assets/icons/chevron-right.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    chevronUp: 'assets/icons/chevron-up.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    circle: 'assets/icons/map/circle.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    circleCrossedOut: 'assets/icons/map/indicators/circle_crossed_out.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    circleEmpty: 'assets/icons/map/circle_empty.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    circle_crossed_out: 'assets/icons/map/indicators/circle_crossed_out.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    circle_empty: 'assets/icons/map/circle_empty.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    close: 'assets/icons/map/close.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cog: 'assets/icons/cog.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    commsTower: 'assets/icons/map/comms_tower.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    commsTrailer: 'assets/icons/map/comms_trailer.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    comms_tower: 'assets/icons/map/comms_tower.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    comms_trailer: 'assets/icons/map/comms_trailer.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'compass-north-outer-ring': 'assets/icons/compass-north-outer-ring.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'compass-outer-ring': 'assets/icons/compass-outer-ring.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    compassNorthOuterRing: 'assets/icons/compass-north-outer-ring.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    compassOuterRing: 'assets/icons/compass-outer-ring.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    cow: 'assets/icons/map/cow.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    crane: 'assets/icons/map/crane.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    crop: 'assets/icons/map/crop.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    crusher: 'assets/icons/map/crusher.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    delete: 'assets/icons/delete.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    diamond: 'assets/icons/map/diamond.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    dozer: 'assets/icons/map/dozer.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    dozerTracked: 'assets/icons/map/dozer_tracked.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    dozerWheeled: 'assets/icons/map/dozer_wheeled.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    dozer_tracked: 'assets/icons/map/dozer_tracked.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    dozer_wheeled: 'assets/icons/map/dozer_wheeled.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    drill: 'assets/icons/map/drill.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'dual-pane': 'assets/icons/dual-pane.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    dualPane: 'assets/icons/dual-pane.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    earth: 'assets/icons/earth.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ednaTest: 'assets/icons/map/edna_test.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    edna_test: 'assets/icons/map/edna_test.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    errorAction: 'assets/icons/error_action.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    error_action: 'assets/icons/error_action.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    excavator: 'assets/icons/map/excavator.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    excavatorReverseBucket: 'assets/icons/map/excavator_reverse_bucket.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    excavator_reverse_bucket: 'assets/icons/map/excavator_reverse_bucket.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'exclamation-sign': 'assets/icons/exclamation-sign.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    exclamationMark: 'assets/icons/map/indicators/exclamation_mark.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    exclamationSign: 'assets/icons/exclamation-sign.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    exclamation_mark: 'assets/icons/map/indicators/exclamation_mark.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    eye: 'assets/icons/eye.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'eye-slash': 'assets/icons/eye-slash.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'eye-slash-half': 'assets/icons/eye-slash-half.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    eyeSlash: 'assets/icons/eye-slash.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    eyeSlashHalf: 'assets/icons/eye-slash-half.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    filterRestore: 'assets/icons/filter_restore.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    filter_restore: 'assets/icons/filter_restore.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    float: 'assets/icons/map/float.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'font-awesome-chart-area': 'assets/icons/font-awesome-chart-area.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    fontAwesomeChartArea: 'assets/icons/font-awesome-chart-area.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    fuelPump: 'assets/icons/map/fuel_pump.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    fuel_pump: 'assets/icons/map/fuel_pump.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    generateCoverage: 'assets/icons/generate_coverage.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    generate_coverage: 'assets/icons/generate_coverage.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    generator: 'assets/icons/map/generator.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    grader: 'assets/icons/map/grader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    health: 'assets/icons/health.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    heatMapIcon: 'assets/icons/heat_map_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    heat_map_icon: 'assets/icons/heat_map_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    home: 'assets/icons/home.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    icon: 'assets/icons/mobile/icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ipDeviceTags: 'assets/icons/ip_device_tags.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ip_device_tags: 'assets/icons/ip_device_tags.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    layer: 'assets/icons/layer.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lighting: 'assets/icons/map/lighting.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'linked-in': 'assets/icons/linked-in.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    linkedIn: 'assets/icons/linked-in.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'lock-fill': 'assets/icons/lock-fill.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lockFill: 'assets/icons/lock-fill.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    logOut: 'assets/icons/log_out.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    log_out: 'assets/icons/log_out.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lvCar: 'assets/icons/map/lv_car.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lvCarIcon: 'assets/icons/lv_car_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lvTruck: 'assets/icons/map/lv_truck.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lv_car: 'assets/icons/map/lv_car.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lv_car_icon: 'assets/icons/lv_car_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    lv_truck: 'assets/icons/map/lv_truck.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    mapLayerIcon: 'assets/icons/map_layer_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    mapMarkerAltSolid: 'assets/icons/map/map_marker_alt_solid.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    mapMarkerPin: 'assets/icons/map_marker_pin.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    map_layer_icon: 'assets/icons/map_layer_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    map_marker_alt_solid: 'assets/icons/map/map_marker_alt_solid.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    map_marker_pin: 'assets/icons/map_marker_pin.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    measuringPoint: 'assets/icons/measuring_point.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    measuring_point: 'assets/icons/measuring_point.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    mic: 'assets/icons/map/mic.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    mob: 'assets/icons/map/mob.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    onClickRf: 'assets/icons/on_click_rf.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    on_click_rf: 'assets/icons/on_click_rf.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    other: 'assets/icons/map/other.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    paddock: 'assets/icons/paddock.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    pasture: 'assets/icons/map/pasture.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    pendingAction: 'assets/icons/pending_action.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    pending_action: 'assets/icons/pending_action.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    person: 'assets/icons/map/person.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    plant: 'assets/icons/map/plant.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    plusSign: 'assets/icons/map/plus_sign.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    plus_sign: 'assets/icons/map/plus_sign.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    pump: 'assets/icons/map/pump.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    radar: 'assets/icons/map/radar.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    redDot: 'assets/icons/map/indicators/red_dot.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    red_dot: 'assets/icons/map/indicators/red_dot.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    redo: 'assets/icons/redo.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    repeat: 'assets/icons/repeat.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    restore: 'assets/icons/restore.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    rfIcon: 'assets/icons/rf_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    rf_icon: 'assets/icons/rf_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    rotable: 'assets/icons/map/rotable.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    router: 'assets/icons/router.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    ruler: 'assets/icons/ruler.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    scaffolding: 'assets/icons/map/scaffolding.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    scissorLift: 'assets/icons/map/scissor_lift.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    scissor_lift: 'assets/icons/map/scissor_lift.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    scrapers: 'assets/icons/map/scrapers.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    search: 'assets/icons/search.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    serviceVehicle: 'assets/icons/map/service_vehicle.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    service_vehicle: 'assets/icons/map/service_vehicle.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    share: 'assets/icons/share.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    shovel: 'assets/icons/map/shovel.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    shovelDigger: 'assets/icons/map/shovel_digger.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    shovel_digger: 'assets/icons/map/shovel_digger.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    snoozingIcon: 'assets/icons/snoozing_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    snoozing_icon: 'assets/icons/snoozing_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    soilAssessment: 'assets/icons/map/soil_assessment.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    soil_assessment: 'assets/icons/map/soil_assessment.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    square: 'assets/icons/map/indicators/square.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    squareSolid: 'assets/icons/map/square_solid.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    square_solid: 'assets/icons/map/square_solid.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    star: 'assets/icons/map/indicators/star.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    starSolid: 'assets/icons/map/star_solid.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    star_solid: 'assets/icons/map/star_solid.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    tableIcon: 'assets/icons/table_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    table_icon: 'assets/icons/table_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    tags: 'assets/icons/tags.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    tally: 'assets/icons/tally.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'tally-white': 'assets/icons/tally-white.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    tallyWhite: 'assets/icons/tally-white.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'timeline-needle': 'assets/icons/timeline-needle.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    timelineNeedle: 'assets/icons/timeline-needle.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    track: 'assets/icons/track.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    trackIcon: 'assets/icons/track_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    track_icon: 'assets/icons/track_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    transmitter: 'assets/icons/map/transmitter.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    trap: 'assets/icons/map/trap.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    trapIcon: 'assets/icons/map/trap_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    trap_icon: 'assets/icons/map/trap_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    trash: 'assets/icons/trash.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    triangle: 'assets/icons/map/triangle.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    truck: 'assets/icons/map/truck.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    undo: 'assets/icons/undo.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'unlock-fill': 'assets/icons/unlock-fill.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    unlockFill: 'assets/icons/unlock-fill.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    user: 'assets/icons/user.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    valve: 'assets/icons/map/valve.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    vegetationPhotoPoint: 'assets/icons/map/vegetation_photo_point.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    vegetation_photo_point: 'assets/icons/map/vegetation_photo_point.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    'video-camera': 'assets/icons/video-camera.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    videoCamera: 'assets/icons/video-camera.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    view: 'assets/icons/view.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    waterPump: 'assets/icons/map/water_pump.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    waterSensor: 'assets/icons/map/water_sensor.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    waterTruck: 'assets/icons/map/water_truck.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    water_pump: 'assets/icons/map/water_pump.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    water_sensor: 'assets/icons/map/water_sensor.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    water_truck: 'assets/icons/map/water_truck.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    website: 'assets/icons/website.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    weed: 'assets/icons/map/weed.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    wheelLoader: 'assets/icons/map/wheel_loader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    wheel_loader: 'assets/icons/map/wheel_loader.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    youtube: 'assets/icons/youtube.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    zone: 'assets/icons/zone.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    zoneIcon: 'assets/icons/zone_icon.svg',
    // DO NOT EDIT THIS FILE: --- npm run buildSvgs --- to regenerate
    zone_icon: 'assets/icons/zone_icon.svg',
} as const;

export type ImsIconUrlLookupKeyType = keyof typeof ImsIconUrlLookupImpl;
type ImsIconUrlLookupType = Record<ImsIconUrlLookupKeyType, string>;
export const ImsIconUrlLookup: ImsIconUrlLookupType = ImsIconUrlLookupImpl;
